import { doShowModal, doHideModal } from 'actions/modals'
import { LABELING_EDIT } from 'constants/modal_types'

export const doShowEditLabelModal = (label, offset) =>
  doShowModal(LABELING_EDIT, { label, offset })

export const doHideEditLabelModal = () => doHideModal(LABELING_EDIT)
